import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const approvalInjectionRBAC = {
  pageID: '765370fa1b9ad79e0780a9c8300fb82f',
  elementID: {
    ViewApprovalInject: '1834b639743313df043846d95affa7c2',
    ApproveRejectButton: '6f12bbbc8f224f3df3ea00c24c3ac517',
  },
} as const

export const useRBACApprovalInjectionPage = createUseRBAC(approvalInjectionRBAC.elementID)

export type UseRBACApprovalInjectionPageType = ReturnType<typeof useRBACApprovalInjectionPage>
